module.exports = __webpack_public_path__ + "img/proceso_c.e1e87147.png";